import { baseConfig } from './APIConfig';
import { HubConnectionBuilder } from '@microsoft/signalr';

const URL = baseConfig.baseurl + "api/signalr/hub";

const signalrHub = new HubConnectionBuilder()
    .withUrl(URL, {
        withCredentials: false
    })
    .withAutomaticReconnect()
    .build();

signalrHub.start().then(result => {
    signalrHub.on('LaunchpadUpdated', message => {
        if (signalrHub.onLaunchpadUpdated != undefined)
            signalrHub.onLaunchpadUpdated();
    });
    signalrHub.on('FeatureUpdated', message => {
        if (signalrHub?.onRefreshPermission) {
            signalrHub.onRefreshPermission();
        }
    });
}).catch(() => {});

signalrHub.onreconnected = () => {
    if (localStorage.getItem('userInfo')) {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (userInfo?.companyid)
            signalrHub.invoke('AddToGroup', userInfo.companyid);
    }
}

export { signalrHub };